import { Component, Input } from '@angular/core';
import { AsyncPipe, DatePipe } from '@angular/common';
import { Message } from '../../../generated-api-proxy';
import { CmsTextPipe } from '../../../pipes/cms-text.pipe';

@Component({
  selector: 'app-small-message-tile',
  standalone: true,
  imports: [DatePipe, CmsTextPipe, AsyncPipe],
  templateUrl: './small-message-tile.component.html',
  styleUrl: './small-message-tile.component.scss'
})
export class SmallMessageTileComponent {
  @Input() message: Message | undefined;
}
